<template>
  <div class="details relative-position">
    <div class="load-data-wrap col is-detail details_data_load" style="margin-top: 266px; display: none;">
      <div class="fit"></div>
      <div class="column yb-flex-center empty">
      </div>
    </div>
    <div class="wrap-handicap v-scroll-area-bar">
      <div class="screen">
        <div class="v-scroll-area fit vrow relative-position">
          <div class="content-wrap fit">
            <div class="scroll-header absolute">
              <div class="wrap-title">
                <div class="group-back cursor-pointer" @click="backToMain()">
                  <i aria-hidden="true" role="presentation" class="back q-icon icon-back c-icon set-color"
                    style="color: rgb(171, 186, 200);"></i>
                </div>
                <div class="title ellipsis allow-user-select" v-html="sortedMatchEventList.lgecapt"></div>
                <div class="right-icon">
                  <span v-if="!showhideBanner" @click="showhide_Banner(true)">{{sportAllBetLang['ALL_BET.LBL_SHOWSCRBOARD']}}</span>
                  <!-- <div class="sr-link-icon-w">
                    <i aria-hidden="true" role="presentation" class="q-icon icon-signal c-icon set-color"
                      style="color: rgb(171, 186, 200);"></i>
                  </div> -->
                  <div class="refresh">
                    <div class="c-refresh fit yb-flex-center cursor-pointer">
                      <div class="icon-wrap" @click="refreshTbl(token.arr_5)">
                        <span class="icon-balance_refresh">
                          <span class="path1"></span>
                          <span class="path2" style="right:27.5px; position:absolute;"></span>
                          <span class="path3" style="right:27.5px; position:absolute;"></span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="showhideBanner" class="head-info relative-position esports-head-info-1" :class="getABetSport()" ref="testa">
                <div class="right_match_info info-upd full-width vrow justify-center">
                  <div class="before">
                    <div class="content" style="box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 15px 0px;">
                      <div class="team">
                        <div class="home">
                          <div class="team_name home-name allow-user-select" v-html="sortedMatchEventList.tacapt"></div>
                          <div class="img-wrap">
                            <!-- <img src="https://image.gredfged.com/group1/M00/00/28/CgURtV7qy6SAIokeAAAjAmZd3ko954.png"
                              alt="" class="team_logo" data-team="A" data-csid="1" style="opacity: 1;"> -->
                          </div>
                        </div>
                        <div class="match_time">
                          <div class="c-match-process text-center match_time-text vrow a-row">
                            <div class="jingcai" style="display: none;"></div>
                            <div class="process-name" style="display: none;">未开赛</div>
                            <div class="c-match-date text-center date-wrap">
                              <template v-if="sortedMatchEventList.rbinfo">
                                <span style="min-width: 60px;font-size: 30px;">
                                  {{sortedMatchEventList.rbinfo.scoa}} - {{sortedMatchEventList.rbinfo.scob}}<br>
                                </span>
                              </template>
                              
                              <span style="min-width: 60px;">
                                
                                <template v-if="sortedMatchEventList.rbinfo && checkTimer(sortedMatchEventList) != ''">
                                  <template v-if="sortedMatchEventList.rbinfo.htst == '0'">
                                    {{ sportTableLang.table['SPORT_TABLE.LBL_HT'] }}
                                  </template>
                                  <template v-else-if="validateRBTimer(sortedMatchEventList) == '1'">
                                    {{ sportTableLang.table['SPORT_TABLE.LBL_1HT'] }}
                                  </template>
                                  <template v-else-if="validateRBTimer(sortedMatchEventList) == '2'">
                                    {{ sportTableLang.table['SPORT_TABLE.LBL_2HT'] }}
                                  </template>
                                  <template v-else> - </template>
                                </template>
                                <template v-else>
                                  <template v-if="selectedLang == 2 || selectedLang == 3">
                                    {{ moment(sortedMatchEventList.dt).locale('cn').format("MMM Do") }} 
                                  </template>
                                  <template v-else>
                                    {{ sortedMatchEventList.dt | date('DD/MM') }}
                                  </template>
                                  <br>
                                </template>
                                
                                <template v-if="sortedMatchEventList.rbinfo && checkTimer(sortedMatchEventList) != ''">
                                  <template v-if="sortedMatchEventList.rbinfo.htst == '0'">
                                  </template>
                                  <template v-else-if="validateRBTimer(sortedMatchEventList) == '1'">
                                    <template v-if="sortedMatchEventList.rbinfo.tlsec">{{ sortedMatchEventList | rb-timer('mm:ss') }}</template>
                                    <template v-else>0</template>'</template>
                                  <template v-else-if="validateRBTimer(sortedMatchEventList) == '2'">
                                    {{ sortedMatchEventList | rb-timer('mm:ss') }}
                                  </template>
                                </template>
                                <template v-else>
                                  {{ sortedMatchEventList.dt | date('HH:mm') }}
                                </template>
                              </span>

                              <span>
                                <template v-if="sortedMatchEventList.rbinfo && checkTimer(sortedMatchEventList) != ''"></template>
                                <template v-else>
                                  {{ sortedMatchEventList.dt | date('HH:mm') }}
                                </template>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="away">
                          <div class="img-wrap">
                            <!-- <img src="https://image.gredfged.com/group1/M00/12/70/CgURtmE22ViARqGwAAAahU51FMk689.png"
                              alt="" class="team_logo" data-team="Y" data-csid="1" style="opacity: 1;"> -->
                          </div>
                          <div class="team_name away-name allow-user-select" v-html="sortedMatchEventList.tbcapt"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="hide-btn" @click="showhide_Banner(false)">{{ sportAllBetLang['ALL_BET.LBL_HIDE'] }}</div>
              </div>
              <div class="scroll-fixed-header wrap-tabs">
                <div class="tabs-panel relative-position">
                  <div class="tab-wrap fit relative-position">
                    <div class="item-wrap relative-position" style="left: 0px;">
                      <div class="tab-item yb-flex-center" :class="{ active: (selectedBetTab == betTab.hot.key) }" @click="chooseBetTab(betTab.hot)">
                        {{ sportAllBetLang['ALL_BET.LBL_HOT'] }}
                      </div>
                      <template v-if="selectedBettype.tmpltId == '1'">
                        <template v-if="checkBTExist('hdpou')">
                          <div class="tab-item yb-flex-center" :class="{ active: (selectedBetTab == betTab.hdpou.key) }" @click="chooseBetTab(betTab.hdpou)">
                            {{ sportAllBetLang['ALL_BET.LBL_HDP_OU'] }}
                          </div>
                        </template>
                        <template v-if="checkBTExist('goals')">
                          <div class="tab-item yb-flex-center" :class="{ active: (selectedBetTab == betTab.goals.key) }" @click="chooseBetTab(betTab.goals)">
                            {{ sportAllBetLang['ALL_BET.SUBHEADER_GOALS'] }}
                          </div>
                        </template>
                        <template v-if="checkBTExist('cs')">
                          <div class="tab-item yb-flex-center" :class="{ active: (selectedBetTab == betTab.cs.key) }" @click="chooseBetTab(betTab.cs)">
                            {{ sportAllBetLang['ALL_BET.SUBHEADER_CS'] }}
                          </div>
                        </template>
                        <!-- <template
                          v-if="sortedMatchEventList.od[ftPlyType] && (sortedMatchEventList.sptid == 1 || sortedMatchEventList.sptid == 13)">
                          <div class="tab-item yb-flex-center" :class="{ active: (selectedBetTab == betTab.ft.key) }"
                            @click="chooseBetTab(betTab.ft)">
                            {{ sportAllBetLang['ALL_BET.LBL_FT'] }}
                          </div>
                        </template> -->
                        <template v-if="sortedMatchEventList.od[firstHtPlyType] && (sortedMatchEventList.sptid == 1 || sortedMatchEventList.sptid == 13)">
                          <div class="tab-item yb-flex-center" :class="{ active: (selectedBetTab == betTab.ht.key) }" @click="chooseBetTab(betTab.ht)">
                            {{ sportAllBetLang['ALL_BET.LBL_HT'] }}
                          </div>
                        </template>
                        <template v-if="sortedMatchEventList.sp">
                          <div class="tab-item yb-flex-center" :class="{ active: (selectedBetTab == betTab.special.key) }" @click="chooseBetTab(betTab.special)">
                            {{ sportAllBetLang['ALL_BET.LBL_SPECIALS'] }}
                          </div>
                        </template>
                        <template v-if="checkBTExist('other')">
                          <div class="tab-item yb-flex-center" :class="{ active: (selectedBetTab == betTab.others.key) }" @click="chooseBetTab(betTab.other)">
                            {{ sportAllBetLang['ALL_BET.LBL_OTHERS'] }}
                          </div>
                        </template>

                      </template>
                      <template v-else-if="selectedBettype.tmpltId == '8'">
                        <!-- Basketball -->
                        <template v-if="selectedBettype.sprtId == 'G1'">

                        </template>
                        <!-- Tennis , Badminton, Volleyball -->
                        <template v-else-if="otherSport1.includes(selectedBettype.sprtId)">
                          <div class="tab-item yb-flex-center" :class="{ active: (selectedBetTab == betTab.sethdp.key) }" @click="chooseBetTab(betTab.sethdp)">
                            {{ sportAllBetLang['ALL_BET.LBL_SET'] }}
                          </div>
                          <div class="tab-item yb-flex-center" :class="{ active: (selectedBetTab == betTab.gamehdp.key) }" @click="chooseBetTab(betTab.gamehdp)">
                            {{ sportAllBetLang['ALL_BET.LBL_GAME'] }}
                          </div>
                        </template>

                        <!--  -->
                        <template v-else-if="selectedBettype.sprtId == 'N24'">

                        </template>
                        <!-- Snooker -->
                        <!-- <template v-else-if="selectedBettype.sprtId == 'N15'"></template> -->
                      </template>
                      <div class="tab-item yb-flex-center" :class="{ active: (selectedBetTab == betTab.all.key) }" @click="chooseBetTab(betTab.all)">
                        {{ sportAllBetLang['ALL_BET.LBL_ALLBET'] }}
                      </div>
                    </div>
                    <div class="left-btn btn" style="display: none;">
                      <div class="yb-icon-arrow"></div>
                    </div>
                    <div class="right-btn btn" style="display: none;">
                      <div class="yb-icon-arrow"></div>
                    </div>
                  </div>
                </div>
                <div class="vrow">
                  <div class="right-icons" @click="foldopenAB()">
                    <i aria-hidden="true" role="presentation" class="q-icon c-icon set-color" :class="{ 'icon-hide': foldopenAllBet, 'icon-open': !foldopenAllBet }"
                      style="color: rgb(90, 96, 116); font-size: 14px;" data-title="dadw"></i>
                  </div>
                </div>
              </div>

            </div>
            <div class="fit v-scrollarea q-scrollarea">
              <div class="q-scrollarea__container scroll relative-position fit hide-scrollbar">
                <div class="q-scrollarea__content absolute">
                  <!-- padding-top: 266px; padding-top: 76px;  -->
                  <div class="middle-content" style="padding-bottom: 0px;" :style="mContentPadding">
                    <div class="scroll-inner-wrap fit" style="height: 572px !important; overflow:auto">
                      <div class="col wrap-scroll">
                        <div class="column fit">
                          <div class="wrap-handicap relative-position details-handicap" screen="match-list">
                            <div id="_handicap_list_wrap" class="template-handicap">
                              <div class="details_data">
                                <div id="_handicap_list" class="group-flex">
                                  <allBetComponent :selTab="selectedBetTab" :betTab="betTab"></allBetComponent>
                                  <!-- <div class="group-template"> -->
                                </div>
                                <div style="margin-top: 20px;">
                                  <div style="height: 152px;">
                                    <div class="go-top to-top">
                                      <div class="go-top-btn" @click="backtoTop()">
                                        <i aria-hidden="true" role="presentation" class="q-icon icon-go_top c-icon"
                                          style="font-size: 14px;"></i>
                                        <div class="vmsg">{{ sportAllBetLang['ALL_BET.BACK_TOP'] }}</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="null-bg" style="display: none;"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div aria-hidden="true" class="q-scrollarea__bar q-scrollarea__bar--v absolute-right"></div>
              <div aria-hidden="true"
                class="q-scrollarea__bar q-scrollarea__bar--h absolute-bottom q-scrollarea__bar--invisible"></div>
              <div aria-hidden="true" class="q-scrollarea__thumb q-scrollarea__thumb--v absolute-right"
                style="right: -10.5px; top: 0px; height: 45px;"></div>
              <div aria-hidden="true"
                class="q-scrollarea__thumb q-scrollarea__thumb--h absolute-bottom q-scrollarea__thumb--invisible"
                style="right: -10.5px; left: 0px; width: 902px;"></div>
            </div>
            <div class="scroll-footer" style="bottom: 0px;"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="refresh-mask absolute-full yb-flex-center" style="top: 36px;" v-show="allBetReloading">
      <div class="img-loading custom-format-img-loading"></div>
    </div>
  </div>
</template>
<script>
import {
  mapGetters
} from 'vuex'
import EventBus from '../../events/event-bus'

import DateFilter from '@/vue/filters/date'
import moment from 'moment'
import 'moment/locale/zh-cn'

// import OddComponents from '../../components/odd'
// import Odd1x2Components from '../../components/odd1x2'
// import HandicapComponents from '../../components/handicap'
// import OverUnderComponents from '../../components/over-under'
// import sportTime from './sportTimeColumn'
// import sportTeam from './sportTeamColumn'

import allBetComponent from './allBet/all-bet'

import allBetMixin from '@/vue/mixins/allBet'
import sportFavourite from '@/vue/mixins/favourite'

export default {
  mixins: [allBetMixin, sportFavourite],
  components: {
    allBetComponent,
    // sportTime,
    // sportTeam,
  },
  computed: {
    ...mapGetters([
      'sportTableLang',
      'sportAllBetLang',
      'matchAllBet',
      'sortedMatchEventList',
      'market',
      'selectedShow',
      'selectedMarket',
      'selectedBettype',
      'tvIconFlag',
      'selectedAllBetNew',
      'foldopenAllBet',
      'allBetReloading',
      'livetv',
    ]),
    livetvEveid: {
      get() {
        return this.$store.getters.livetv.eveid;
      }
    },
  },
  watch: {
    'showhideBanner': {
      handler(val, oldVal) {
        this.allBet_mContent()
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      selectedLang: window._langid,
      lang: window.lang,
      fT: ['2', '3'],
      hT: ['2', '4'],
      showhideAll: true,
      selectedBetTab: 'hot',
      otherSport1: ['N3', 'N12', 'N21'],  //tennis,badminton,volleyball
      betTab: {
        hot: {
          key: 'hot',
          value: true,
          flag: true,
        },
        hdpou: {
          key: 'hdpou',
          value: [1,2,4,32,46,48], //bettype in allbet mixin
          rbvalue: [8,9,11,33,47,49],
          flag: true,
        },
        goals: {
          key: 'goals',
          value: [2, 3, 5], //bettype in allBet mixin
          rbvalue: [18, 9, 10],
          flag: true,
        },
        cs: {
          key: 'cs',
          value: [7], //bettype in allBet mixin
          rbvalue: [16],
          flag: true,
        },
        ft: {
          key: 'ft',
          value: [1], //plytyp in allbet mixin
          rbvalue: [8],
          flag: true,
        },
        ht: {
          key: 'ht',  //first half
          value: [2], //plytyp in allbet mixin
          flag: true,
        },
        others: {
          key: 'others',
          value: true,
          flag: true,
        },
        special: {
          key: 'special',
          value: true,
          flag: true,
        },
        other: {
          key: 'other',
          value: [21,34,28,30],
          rbvalue: [27,29,35,31],
          flag: true,
        },
        scrMarket: {
          key: 'scrMarket',
          value: [2, 3, 5, 7, 9, 10], //bettype in allBet mixin
          flag: true,
        },
        sethdp: {
          key: 'set',
          value: [3, 7, 8, 9, 10, 11, 12],
          rbvalue: [27,29,35,31],  //rbettype in allBet mixin
          flag: true,
        },
        gamehdp: {
          key: 'game',
          value: [6],
          flag: true,
        },
        pointhdp: {
          key: 'point',
          value: [4],
          flag: true,
        },
        all: {
          key: 'all',
          value: true,
          flag: true,
        },
      },
      showhideBanner: true,
      mContentPadding: '',
      reloading: false,
      bannerSize: 190,
      liveTvheight:290
    }
  },
  methods: {
    checkBTExist(BTkey) {
      let vue = this
      // let btKey = BTkey
      let exist = false
      let btArray = (this.sortedMatchEventList.rbinfo) ? vue.betTab[BTkey].rbvalue : vue.betTab[BTkey].value

      _.forEach(this.sortedMatchEventList.od, function (data, key) {
        _.forEach(data, function (val, k) {
          if ($.inArray(parseInt(k), btArray) > -1) {
            exist = true
          }
        })
      })

      return exist
    },
    allBet_mContent(){
      var a = 76
      var b = (this.showhideBanner) ? a + this.bannerSize : a
      if(this.livetvEveid>0 && this.showhideBanner){
        b=400
      }
      this.mContentPadding = 'padding-top: '+b+'px;'
    },
    showhide_Banner(val){
      this.showhideBanner = val
      // this.allBet_mContent()
    },
    getABetSport() {
      var sprt = this.$store.getters.selectedBettype.sprtId

      return 'allBet'+sprt
    },
    foldopenAB() {
      this.$store.commit('FOLDOPEN_ALLBET', !this.$store.getters.foldopenAllBet)
    },
    backtoTop() {
      $(".list-scrollbar").animate({ scrollTop: 0 },100);
    },
    showhideMain() {
      this.showhideAll = (this.showhideAll) ? false : true;
      this.$set(this.sortedMatchEventList, 'hide', !this.sortedMatchEventList.hide)
    },
    colspanS() {
      // return (this.selectedMarket == 3) ? 2 : 3
      return 2
    },
    getSubMatch(sub) {
      return sub + 1
    },
    showLeg() {
      this.$set(this.sortedMatchEventList, 'hide', !this.sortedMatchEventList.hide)
    },
    chooseBetTab(betTab) {
      if (betTab.flag) {
        this.selectedBetTab = betTab.key
      }
      // this.switchAllBetTab(id)
    },
    switchAllBetTab(id) {
      $('.moreBetTypeNav-Item').removeClass('active');
      $(id).addClass('active');
    },
    checkOpenMore(event) {
      if (event.sp) {
        return true;
      } else if (event.od) {
        var show = true
        $.each(event.od, function (plyTypes, drawBt) {
          if (plyTypes !== '1' && plyTypes !== '3') {
            return true;
          } else {
            show = true
            if (plyTypes == '1' || plyTypes == '2') {
              $.each(drawBt, function (bidx, drawDual) {
                show = true
                //HDP,OU,1x2,RHDP,ROU,R1x2,ML
                if (bidx == 1 || bidx == 2 || bidx == 4 || bidx == 8 || bidx == 9 || bidx == 11) {
                  show = false
                }
              });
            }
          }
        });
        return show;
      }
      return false;
    },
    reloadTable(token_val = '') {
      this.oddsReload = true
      // this.clearTimer()
      EventBus.$emit('templateChange', this.oddsReload);
      // this.reloadingPer = '25%';
      var dispatchName = 'getSportOdds'
      if (this.$store.getters.selectedBettype.betTypId == '6') { //if is outright
        dispatchName = 'getSportOutrightOdds'
      }
      if (token_val == '' || token_val == undefined) {
        token_val = token.arr_8
      }
      // this.reloadingPer = '80%';
      this.$store.dispatch(dispatchName, {
        token: token_val,
        callback: ((res) => {
          if (res.events) {
            // this.timerSeconds = this.getMarketTimer(this.$store.getters.selectedMarket)
            // this.startTimer()
            // clearInterval(this.reconnectTimerId)
            this.reconnectTimerId = null
            _.forEach(res.events, function (val, key) {
              _.forEach(val, function (v, k) {
                var showAllBet = $('#moreExpand' + v.eveid).hasClass('icon-moreCollapse')
                if (showAllBet) {
                  $('#moreExpand' + v.eveid).addClass('icon-moreExpand')
                  $('#moreExpand' + v.eveid).removeClass('icon-moreCollapse')
                  $('#moreBets' + v.eveid).css("display", "none");
                }
              })
            })
          } else {
            this.reconnectTimerSeconds = 5;
            if (this.reconnectTimerId == null) {
              this.reconnectTimerId = setInterval(() => {
                if (this.reconnectTimerSeconds - 1 < 0) {
                  this.reloadTable()
                } else {
                  this.reconnectTimerSeconds -= 1;
                }
              }, 1000);
            }
          }
          if (this.showFavEvents) {
            this.$store.dispatch('getLaugueList', (function (res) {
              this.$store.commit('SELECTEDLEAGUES', Object.keys(this.$store.getters.arr_leagueList).length)
              this.$store.commit('TOTALLEAGUES', Object.keys(this.$store.getters.arr_leagueList).length)
            }).bind(this))
          }
          this.reloading = false
          this.oddsReload = false
          EventBus.$emit('templateChange', this.oddsReload);
          // this.refreshScroll()

          this.$store.commit('PARLAY_SELECTED', { update: false })
        }).bind(this)
      })
    },
    backToMain() {
      EventBus.$emit('sportTableReloading', true)
      this.reloadTable()
      this.$store.commit('SELECTED_MATCHALLBET', false)
    },
    clearTimer() {
      clearInterval(this.timerId)
      this.timerId = null
    },
    getMarketTimer(selMarket) {
			if (this.$store.getters.open_RBMarket) {
				return this.rbTimer
			} else if (selMarket == this.$store.getters.market.earlyMarket.key) {
				return this.earlyTimer
			} else if (selMarket == this.$store.getters.market.tdyMarket.key) {
				return this.todayTimer
			}
		},
    startAllBetTimer() {
			if (this.timerId == null) {
				this.timerId = setInterval(() => {
				if (this.timerSeconds - 1 < 0) {
					// this.reloadTable(token.arr_1)
					this.refreshTbl(token.arr_1)
				} else {
					this.timerSeconds -= 1;
				}
				}, 1000);
			}
		},
    refreshTbl(token_val) {
      this.reloading = (token_val == token.arr_1 || token_val == token.arr_5) ? false : true
      if (this.selectedMatchAllBet) {
        this.reloadAllBetTable(token_val)
      }
    },
    reloadAllBetTable(token_val = '') {
			if (token_val == '') {
				token_val = token.arr_5
			}
      this.clearTimer()
			// this.reloadingPer = '25%';
			this.cloneEventAllBet = _.cloneDeep(this.$store.getters.sortedMatchEventList)

			// this.reloadingPer = '80%';
			this.$store.dispatch('getSportAllBet', {
				token: token_val,
				inAllBet: true,
				event: this.$store.getters.sortedMatchEventList,
				callback: ((res) => {
				this.timerSeconds = this.getMarketTimer(this.$store.getters.selectedMarket)

				this.startAllBetTimer()
				this.mainMarketList = _.cloneDeep(this.$store.getters.sortedMatchEventList)

				this.$nextTick(() => {
					EventBus.$emit('diffOdd', this.cloneEventAllBet)
				})
				this.reloading = false
				}).bind(this)
			})
		},
    checkTimer(event) {
      return this.$options.filters.checkTimer(event)
    },
  },
  mounted () {
    this.allBet_mContent()
  },
  beforeMount(){
    if(this.sortedMatchEventList.rbinfo && this.$store.getters.selectedMarket == this.$store.getters.market.tdyMarket.key){
      this.$store.commit('IS_TODAYRB', true)
    }else if(this.$store.getters.selectedMarket == this.$store.getters.market.tdyMarket.key){
      this.$store.commit('IS_TODAYRB', false)
    }
    this.timerSeconds = this.getMarketTimer(this.$store.getters.selectedMarket)
    this.startAllBetTimer()
  },
  destroyed () {
    this.clearTimer()
  },
}
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/soccerAllCommon.vue